/// <reference path="PickAssistant.ts" />

namespace TerminalApp {
    export class PlacementShortcutAssistant extends PickAssistant<any> {
        pi: PlacementInfoBox;
        header = document.createElement("div");
        itemInfo: SP.ItemInfo;
        constructor() {
            super(SP.Localize("word_placement") + " " + SP.Localize("word_shortcuts"));

            this.dm_active_container.prepend(this.header);
            this.header.classList.add("btn");


            //Audit button1
            this.addItem(null, true, SP.Localize("sentance_stock_audit"), SP.Localize("description_audit_placement"), "fa-solid fa-calculator", "black", async () => {
                SP.setAllHash({ "app": "app_audit_stock", "placementId": this.pi.id.toString() });
                this.close();
            });

            //Audit button2
            this.addItem(null, true, SP.Localize("sentance_placement_audit"), SP.Localize("description_audit_placement"), "fa-solid fa-calculator", "black", async () => {
                SP.setAllHash({ "app": "app_audit_placement", "placementId": this.pi.id.toString() });
                this.close();
            });

            //Audit button2
            this.addItem(null, true, SP.Localize("sentance_move_from_placement"), SP.Localize("description_move_from_placement"), "fa-solid fa-arrow-turn-down-right", "black", async () => {
                SP.setAllHash({ "app": "app_move_stock", "placementId": this.pi.id.toString(), "filter": this.itemInfo ? this.itemInfo.sku : "" });
                this.close();
            });
        }

        async open_with_data(data: string, itemInfo: SP.ItemInfo) {
            this.itemInfo = itemInfo;
            this.pi = new PlacementInfoBox(data, true, itemInfo);
            this.header.innerHTML = "";
            this.header.appendChild(this.pi.container);
            super.open(null);
        }

        async open_with_id(id: number) {
            let pi = await SP.Data.Stock.getPlacementInfo(id);
            this.open_with_data(pi.data, null);
        }
    }
}